import axios from 'axios';

import routes from 'app/routes';

const prepareParams = (values) => ({
  first_name: values.firstName,
  last_name: values.lastName,
  email: values.email,
});

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.managers.coaches.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', coaches: resp.data.data });
      });
  },

  update: (dispatch, coachId, values, successCallback, errorCallback) => {
    axios
      .put(routes.api.managers.coaches.update(coachId), prepareParams(values))
      .then((resp) => {
        dispatch({ type: 'UPDATE', coach: resp.data.data });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  activate: (dispatch, coachId) => {
    axios
      .post(routes.api.managers.coaches.activate(coachId))
      .then((resp) => {
        dispatch({ type: 'UPDATE', coach: resp.data.data });
      });
  },

  block: (dispatch, coachId) => {
    axios
      .post(routes.api.managers.coaches.block(coachId))
      .then((resp) => {
        dispatch({ type: 'UPDATE', coach: resp.data.data });
      });
  },

  manualImport: (coaches, callback) => {
    axios
      .post(routes.api.managers.coaches.manualImport, {
        coaches,
      })
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  invite: (coachEmails, callback) => {
    axios
      .post(routes.api.managers.coaches.invite, {
        coaches: coachEmails,
      })
      .then((resp) => {
        callback(resp.data.data);
      });
  },

};
